import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { SecureComponent } from './secure.component';
import { HomeComponent } from './home/home.component';
import { LoggedInGuard } from 'src/app/Helpers/Guards/loggedin.guard';
import { AdminGuard } from 'src/app/Helpers/Guards/admin.guard';
import { QuestionarioComponent } from './questionario/questionario.component';
import { PaginaNaoEncontradaComponent } from 'src/app/Components/pagina-nao-encontrada/pagina-nao-encontrada.component';
import { CadastroComponent } from './cadastro/cadastro.component';

const SECURE_ROUTES: Routes = [
  {
    path: 'secure',
    component: SecureComponent,
    canActivate: [AdminGuard],
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'admin',
        canActivate: [AdminGuard],
        loadChildren: () => import('../secure/admin/admin.module')
          .then(mod => mod.AdminModule)
      }
    ]
  },
  {
    path: 'participante',
    component: SecureComponent,
    canActivate: [LoggedInGuard],
    children: [
      {
        path: '',
        canActivate: [LoggedInGuard],
        component: HomeComponent,
      },
      {
        path: 'perfil',
        component: CadastroComponent
      },
      {
        path: 'area-participacao',
        component: PaginaNaoEncontradaComponent
      },
      {
        path: 'area-participacao/:areaParticipacaoId',
        component: PaginaNaoEncontradaComponent
      },
      {
        path: 'area-participacao/:areaParticipacaoId/pergunta',
        component: PaginaNaoEncontradaComponent
      },
      {
        path: 'area-participacao/:areaParticipacaoId/pergunta/:perguntaId',
        component: QuestionarioComponent
      },
      {
        path: 'area-participacao/:areaParticipacaoId/perguntas/:Ids',
        component: QuestionarioComponent
      },
      {
        path: '**', component: PaginaNaoEncontradaComponent
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(SECURE_ROUTES, { enableTracing: true })
  ],
  exports: [
    RouterModule
  ]
})
export class SecureRoutingModule { }
